import { css } from '@emotion/core';
import styled from '@emotion/styled';

const wrapperStyles = ({
  theme: {
    work,
    grid: { breakpoint },
  },
}) => css`
  background: ${work.sesamePrimary};
  padding: 70px 15px 40px;
  margin: 0 -15px;
  ${breakpoint.min730} {
    padding: 0;
    margin: auto;
    display: grid;
    min-height: 100vh;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    padding: 0;
  }
`;

const imageWrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => `
  width: 100%;
  margin: 0 auto;
  ${breakpoint.min730} {
    max-width: 1500px;
  }
`;

const sectionStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  display: grid;
  row-gap: 0;
  grid-template-areas:
    'image'
    'data-driven-solutions'
    'analytics-infrastructure'
    'graphql-infrastructure'
    'monitoring'
    'interviews';
  ${breakpoint.fromPhoneMedium} {
    column-gap: 30px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      'image                    image'
      'data-driven-solutions    data-driven-solutions'
      'analytics-infrastructure analytics-infrastructure'
      'monitoring               interviews'
      'graphql-infrastructure   graphql-infrastructure';
  }
  ${breakpoint.min730} {
    margin: 0 150px;
    grid-template-columns: repeat(8, 300px);
    grid-template-areas:
      '. data-driven-solutions image image image image interviews interviews'
      'analytics-infrastructure analytics-infrastructure image image image image graphql-infrastructure monitoring';
    column-gap: 40px;
    align-self: center;
  }
`;

const blockStyles = ({
  theme: {
    color,
    grid: { breakpoint },
  },
  gridArea,
}) => css`
  grid-area: ${gridArea};
  border-top: 1px solid ${color.whiteTransparent60};
  padding-top: 30px;
  padding-bottom: 30px;
  ${breakpoint.min730} {
    padding-top: 40px;
    padding-bottom: 0;
  }
`;

const blockWithImageStyles = ({
  gridArea,
  theme: {
    grid: { breakpoint },
  },
}) =>
  gridArea === 'image' &&
  css`
    border-top: none;
    padding: 0;
    ${breakpoint.min730} {
      padding: 0;
    }
  `;

const blockWithExtraSpacingStyles = ({
  gridArea,
  theme: {
    grid: { breakpoint },
  },
}) =>
  (gridArea === 'interviews' || gridArea === 'data-driven-solutions') &&
  css`
    ${breakpoint.min730} {
      padding-bottom: 40px;
    }
  `;

/**
 * Component style declarations
 */
export const Wrapper = styled('div')(wrapperStyles);
export const Section = styled('div')(sectionStyles);
export const ImageWrapper = styled('div')(imageWrapperStyles);
export const Block = styled('div')(blockStyles, blockWithImageStyles, blockWithExtraSpacingStyles);
